import { Component } from '@angular/core';
import { AppService } from '../../app.service';
import { ApiService } from '../../share/services/api.service';
import { Member } from '../../share/models/member.model';
import { LogLogging } from '../../share/models/log-logging-model'; 
import { SharedModule } from '../../share/shared.module';

@Component({
  selector: 'app-home',
  templateUrl: './members.component.html',
  imports: [ SharedModule]
})
export class MembersComponent {

  members: Member[] = [];
  logs: LogLogging[] = [];
  isLoaded = false;

  constructor(public appService: AppService, private api: ApiService) {
    this.appService.pageTitle = 'Fetrapi Members';
  }

  ngOnInit() {
    //this.api.getMembers().subscribe((data: any) => { 
    //  this.members = data;
    //  this.isLoaded = true;
    //})

    this.api.getLogs().subscribe((data: any) => {
      this.logs = data;
      this.isLoaded = true;
    }) 
  }

  getLogDate(log: LogLogging) {
    return new Date(log.dateTimeCreated);
  }
  
}
